import {colors, useTheme} from "@mui/material";
import {themeOptions} from "../App";

const colorConfigs = {
  sidebar: {
    // bg: "#233044",
    bg: "#233044",
    // color: "#eeeeee",
    color: "#020202",
    hoverBg: "rgba(132,166,127,0.64)",
    activeBg: "#84a67f"
  },
  topbar: {
    bg: "#fff",
    color: "#000"
  },
  mainBg: "#fffaf2"
};

export default colorConfigs;